<nz-page-header [nzGhost]="false" class=" !bg-blue-300 dark:!bg-navy-700 !sticky top-0 z-50">
    <nz-page-header-title>
        <h1 class="text-[60px] text-sky-800 dark:text-accent-light/80 mb-0">{{'god_user.title' | translate}}</h1>
    </nz-page-header-title>
</nz-page-header>
<div class="w-[90%] m-auto mt-2 mb-2">
    <button class="flex float-right mb-2 bg-blue-300 hover:bg-blue-600 text-white font-bold py-2 px-2 rounded"
        (click)="openModal('CREATE')">{{'god_user.create' | translate}}</button>
</div>
<div class="w-[90%] m-auto card rounded-xl border-none mt-5 dark:bg-navy-800 dark:text-[#818cf8]">
    <nz-table nzTemplateMode class="rounded-lg bg-white dark:border-navy-700 dark:bg-navy-800 text-center"
        nzShowSizeChanger [nzScroll]="{ x: '1150px' }" [nzData]="_godUsers" [nzFrontPagination]="false"
        [nzLoading]="_loading" [nzTotal]="_totalItems" [nzPageSize]="_paging.pageSize" [nzPageIndex]="_paging.pageIndex"
        (nzQueryParams)="onQueryChange($event)">
        <thead nzSingleSort>
            <tr class="dark:hover:bg-navy-450">
                <th class=" dark:bg-navy-800 dark:text-[#818cf8]">{{'table.username' | translate}}</th>
                <th class=" dark:bg-navy-800 dark:text-[#818cf8]">{{'table.metadata' | translate}}</th>
                <th class=" dark:bg-navy-800 dark:text-[#818cf8] w-auto">{{'table.option' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            @for (row of _godUsers; track $index) {
            <tr class="bg-white dark:border-navy-700 dark:bg-navy-800 dark:text-navy-100 dark:hover:bg-navy-450">
                <td nzLeft>{{row.username}}</td>
                <td nzLeft>
                    <pre class="text-xs bg-gray-100 dark:bg-navy-600 p-2 rounded">{{row.metadata | json}}</pre>
                </td>
                <td nzAlign="center">
                    <div class="flex gap-1 justify-center">
                        <!-- <div>
                            <button
                                class="flex items-center bg-blue-300 hover:bg-blue-600 text-white font-bold py-2 px-2 rounded m-auto"
                                (click)="openModal('EDIT',row)">
                                <svg class="w-4 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                </svg>
                            </button>
                        </div> -->
                        <div>
                            <button
                                class="flex items-center bg-red-300 hover:bg-red-600 text-white font-bold py-2 px-2 rounded m-auto"
                                nz-popconfirm nzPopconfirmTitle="Vuoi eliminare?"
                                (nzOnConfirm)="openModal('DELETE',row)" (nzOnCancel)="noDelete()"
                                nzPopconfirmPlacement="topRight">
                                <svg viewBox="0 0 1024 1024" fill="#ffffff" class="icon w-4 h-5" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M512 897.6c-108 0-209.6-42.4-285.6-118.4-76-76-118.4-177.6-118.4-285.6 0-108 42.4-209.6 118.4-285.6 76-76 177.6-118.4 285.6-118.4 108 0 209.6 42.4 285.6 118.4 157.6 157.6 157.6 413.6 0 571.2-76 76-177.6 118.4-285.6 118.4z m0-760c-95.2 0-184.8 36.8-252 104-67.2 67.2-104 156.8-104 252s36.8 184.8 104 252c67.2 67.2 156.8 104 252 104 95.2 0 184.8-36.8 252-104 139.2-139.2 139.2-364.8 0-504-67.2-67.2-156.8-104-252-104z"
                                            fill=""></path>
                                        <path d="M707.872 329.392L348.096 689.16l-31.68-31.68 359.776-359.768z" fill="">
                                        </path>
                                        <path d="M328 340.8l32-31.2 348 348-32 32z" fill=""></path>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
            } @empty {
            <tr class="dark:bg-navy-800  dark:text-[#818cf8]">
                <td colspan="3" class="dark:border-navy-700">
                    <nz-empty [nzNotFoundContent]="contentTpl">
                        <ng-template #contentTpl>
                            <span> {{'table.noData' | translate}} </span>
                        </ng-template>
                    </nz-empty>
                </td>
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<nz-modal [(nzVisible)]="_isVisible" nzTitle="{{_modalType}}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
        <nz-row class="text-center">
            <nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label [nzSpan]="6" class="mt-2">{{'table.username' | translate}}<span class="text-red-500">*</span></nz-form-label>
                    <nz-form-control [nzSpan]="14">
                        <input nz-input [(ngModel)]="_godUser.username" #username="ngModel" required>
                        @if(username.invalid && username.touched){<div class="text-red-500">{{'alert.error.requiredField' | translate}}</div>}
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label [nzSpan]="6" class="mt-2">{{'table.password' | translate}}<span class="text-red-500" *ngIf="!_isEdit">*</span></nz-form-label>
                    <nz-form-control [nzSpan]="14">
                        <input nz-input type="password" [(ngModel)]="_godUser.password" #password="ngModel" [required]="!_isEdit" placeholder="{{ _isEdit ? ('modal.leaveBlank' | translate) : '' }}">
                        @if(password.invalid && password.touched && !_isEdit){<div class="text-red-500">{{'alert.error.requiredField' | translate}}</div>}
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label [nzSpan]="6" class="mt-2">{{'table.metadata' | translate}}</nz-form-label>
                    <nz-form-control [nzSpan]="14">
                        <textarea nz-input rows="4" [(ngModel)]="_godUser.metadata" placeholder='{ "key": "value" }'></textarea>
                    </nz-form-control>
                </nz-form-item>
            </nz-col>
        </nz-row>
    </ng-container>
</nz-modal>